import { z } from 'zod';
export const loginSchema = z.object({
    email: z.string().email('Please enter a valid email address'),
    rememberMe: z.boolean().optional(),
});
export const otpSchema = z.object({
    otp1: z.string().length(1, 'Required'),
    otp2: z.string().length(1, 'Required'),
    otp3: z.string().length(1, 'Required'),
    otp4: z.string().length(1, 'Required'),
    otp5: z.string().length(1, 'Required'),
    otp6: z.string().length(1, 'Required'),
});
